import type { ReactNode } from 'react'
import type { AppConfigContextValue } from './types'

import { useMemo } from 'react'

import { AppConfigContext } from './context'

const EMPTY_GATES: Record<string, boolean> = {}
const EMPTY_CONFIGS: Record<string, Record<string, unknown>> = {}

interface MockAppConfigProviderProps {
  children: ReactNode
  gates?: Record<string, boolean>
  configs?: Record<string, Record<string, unknown>>
}

export function MockAppConfigProvider({
  children,
  gates = EMPTY_GATES,
  configs = EMPTY_CONFIGS,
}: MockAppConfigProviderProps) {
  const value = useMemo<AppConfigContextValue>(
    () => ({
      checkFeatureFlag: (name: string) => gates[name] ?? false,
      getRemoteConfig: (name: string) => configs[name] ?? {},
    }),
    [gates, configs],
  )

  return (
    <AppConfigContext.Provider value={value}>
      {children}
    </AppConfigContext.Provider>
  )
}
